/**
 * 全站 API / 认证路径常量 — 单一可信源 (SSOT)。
 *
 * 设计目标：所有「基础 URL / 认证端点」集中定义在此，调用方一律从这里
 * 派生，杜绝散落的硬编码字符串。
 *
 * release-channel 的命名空间约定（2026-05-21 v1↔v2 合并后）：
 * - 业务路由统一挂在 `/api/v1/*`（axios 默认基址）。
 * - `version` 与 passgate 认证流（feishu / config）是平台级契约，挂在
 *   版本化命名空间之外的 `/api/*`，调用时显式覆盖基址为 PLATFORM_API_BASE。
 */

/** 业务 API 基址（版本化命名空间）。 */
export const API_BASE = '/api/v1'

/** 平台级 API 基址（version + passgate 认证流，非版本化）。 */
export const PLATFORM_API_BASE = '/api'

/** passgate 认证路由前缀。 */
export const AUTH_PREFIX = `${PLATFORM_API_BASE}/auth`

/** passgate 角色 / appid 配置端点（AppLayout 调整角色跳转用）。 */
export const API_AUTH_CONFIG = `${AUTH_PREFIX}/config`

/** passgate 飞书 OAuth 登录入口（返回 { login_url }）。 */
export const API_AUTH_FEISHU = `${AUTH_PREFIX}/feishu`

// 登出常量已移除(RFC-0128)：登出改为整页导航到同源后端 `/logout`
// (broodbridge.install_logout_route),后端可靠删三类 cookie 并 302 到 /login。
// 旧的跨域 `PASSGATE_SSO_LOGOUT_URL` / 同源 `API_AUTH_LOGOUT` fetch 都不可靠清
// 父域 HttpOnly SSO cookie（正是被静默登回的根因），故删除。
